// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__7RQJ5","overflowing":"ReadFullNote_overflowing__3DTDd"};